<template>
  <div class="home">
    <el-row :gutter="10">
      <el-col :span="8">
        <BiHeader
          :header-config="{ title: '经营概况' }"
          tabs-show
          :item-data="[
            { desc: '昨日', code: 1 },
            { desc: '本月', code: 2 },
          ]"
          @selectTabs="selectTabs1"
        >
          <div class="flex-x mt20 mb10">
            <div
              class="flex-y item"
              style="flex: 1; align-items: center; justify-content: center"
              v-for="(item, index) in source1"
              :key="index"
            >
              <div class="price">
                <Roller :text="numToWan(isType(item))" :transition="2" />
              </div>
              <div class="title">
                {{ item.name }}
              </div>
            </div>
          </div>
        </BiHeader>
      </el-col>
      <el-col :span="8">
        <BiHeader
          :header-config="{ title: '销售出库量' }"
          tabs-show
          :item-data="[
            { desc: '昨日', code: 1 },
            { desc: '本月', code: 2 },
          ]"
          @selectTabs="selectTabs2"
        >
          <div class="flex-x mt20 mb10">
            <div
              class="flex-y item"
              style="flex: 1; align-items: center; justify-content: center"
              v-for="(item, index) in source2"
              :key="index"
            >
              <div class="price">
                <Roller :text="numToWan(isType(item))" :transition="2" />
              </div>
              <div class="title">
                {{ item.name }}
              </div>
            </div>
          </div>
        </BiHeader>
      </el-col>
      <el-col :span="8">
        <BiHeader
          :header-config="{ title: '销售单品库存量', text: '截止到昨日' }"
        >
          <div class="flex-x mt20 mb10">
            <div
              class="flex-y item"
              style="flex: 1; align-items: center; justify-content: center"
              v-for="(item, index) in source3"
              :key="index"
            >
              <div class="price">
                <Roller :text="numToWan(isType(item))" :transition="2" />
              </div>
              <div class="title">
                {{ item.name }}
              </div>
            </div>
          </div>
        </BiHeader>
      </el-col>
    </el-row>
    <BiHeader :header-config="{ title: '常用功能' }">
      <div class="flex-x" style="flex-wrap: wrap">
        <div
          style="margin-left: 30px; margin-right: 30px"
          v-for="(item, index) of usedTable"
          :key="index"
          class="flex-y changyong"
          @click="goto(item, 2)"
        >
          <div class="iconitem mt20">
            <vab-icon :icon="item.icon" />
          </div>
          <div style="font-size: 14px; margin-top: 20px; margin-bottom: 20px">
            {{ item.menuName }}
          </div>
        </div>
      </div>
    </BiHeader>
    <BiHeader :header-config="{ title: '快捷查询' }">
      <div class="flex-x">
        <el-select
          v-model="value"
          class="mt10 mb10"
          filterable
          remote
          style="width: 400px"
          reserve-keyword
          placeholder="请输入您想找的菜单名称"
          :remote-method="remoteMethod"
          :loading="loading"
          value-key="value"
          @change="handleChange($event)"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item"
          />
        </el-select>
        <div
          v-for="(itemA, index) of searchData"
          :key="index"
          class="flex-y mb10"
        >
          <div style="font-size: 16px">{{ itemA.name }}</div>
          <div class="flex-x" style="flex-wrap: wrap">
            <div
              v-for="(itemB, indexChild) of itemA.child"
              :key="indexChild"
              class="flex-x childItem"
              style="align-items: center"
              @click="goto(itemB, 3)"
            >
              <div class="iconitem">
                <vab-icon :icon="itemB.icon" />
              </div>
              <div class="flex-y ml10">
                <div style="font-size: 14px; margin-bottom: 5px">
                  {{ itemB.title }}
                </div>
                <div class="text-muted" style="font-size: 12px">
                  {{ itemB.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BiHeader>
    <div style="height: calc(100vh - 540px)"></div>
    <vab-footer />
  </div>
</template>

<script>
  import { homeMenuList, homepageMenuList, homeMenuAdd } from '@/api/common.js'
  import {
    shopHomeOverviewList,
    performanceHomeOverviewList,
    stockHomeOverviewList,
  } from '@/api/common.js'
  import BiHeader from '@/views/bi/components/BiHeader'
  import Roller from 'vue-roller'
  export default {
    name: 'Index',
    components: {
      BiHeader,
      Roller,
    },
    data() {
      return {
        usedTable: [],
        searchData: [],
        value: '',
        loading: false,
        options: [],
        source1: [],
        source2: [],
        source3: [],
        list: [],
        iconData: [
          'align-left',
          'apps-2-line',
          'article-line',
          'file-copy-2-line',
          'building-2-line',
          'copper-coin-line',
          'community-line',
          'file-settings-line',
          'file-upload-line',
          'folder-2-line',
          'folder-open-line',
          'function-line',
          'home-wifi-line',
          'handbag-line',
          'list-unordered',
          'list-settings-line',
          'magic-line',
        ],
      }
    },
    created() {
      this.getuserMenuList()
      this.getRoutersList()
      this.getData()
    },
    activated() {
      this.getuserMenuList()
    },
    mounted() {},
    methods: {
      getData() {
        let params = {
          beginTime: '',
          endTime: '',
        }

        // 获取当前日期
        const today = new Date()
        // 计算昨天的日期（当前时间减去一天的毫秒数）
        const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)

        // 格式化日期为 yyyy-mm-dd 格式
        const year = yesterday.getFullYear()
        const month = String(yesterday.getMonth() + 1).padStart(2, '0')
        const day = String(yesterday.getDate()).padStart(2, '0')
        const dateStr = `${year}-${month}-${day}`

        params.beginTime = `${dateStr} 00:00:00`
        params.endTime = `${dateStr} 23:59:59`
        performanceHomeOverviewList(params).then((res) => {
          this.source1 = res.data
        })
        shopHomeOverviewList(params).then((res) => {
          this.source2 = res.data
        })
        stockHomeOverviewList().then((res) => {
          this.source3 = res.data
        })
      },
      getRoutersList() {
        homepageMenuList().then((res) => {
          this.list = res.data.list.map((item, index) => {
            return {
              value: `${index}`,
              label: `${item.menuName}`,
              name: this.capitalizeFirstLetter(item.path),
            }
          })
        })
      },

      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      handleChange(row) {
        homeMenuAdd({ path: row.name }).then(() => {
          this.$router.push({
            name: row.name,
          })
        })
      },
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true
          setTimeout(() => {
            this.loading = false
            this.options = this.list.filter((item) => {
              return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
            })
          }, 200)
        } else {
          this.options = []
        }
      },
      getuserMenuList() {
        homeMenuList().then((res) => {
          res.data.forEach((item) => {
            item.icon = this.getRandomElement(this.iconData)
          })
          this.usedTable = res.data
        })
      },
      getRandomElement(arr) {
        const index = Math.floor(Math.random() * arr.length)
        return arr[index]
      },
      goto(row, type) {
        if (type == 2 || type == 3) {
          homeMenuAdd({ path: row.path }).then(() => {
            this.$router.push({
              name: row.path,
            })
          })
        }
      },
      isType(item) {
        if (item.type == 2) {
          return this.numToMoneyField(Number(item.value).toFixed(2))
        } else if (item.type == 3) {
          return item.value + '%'
        } else {
          return this.numToMoneyField(item.value)
        }
      },
      numToMoneyField(inputString) {
        let regExpInfo = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g
        var ret = inputString.toString().replace(regExpInfo, '$1,')
        return ret
      },
      numToWan(inputString) {
        // 去掉千分位逗号
        let num = Number(String(inputString).replace(/,/g, ''))
        if (num >= 100000) {
          let result = (num / 10000).toFixed(2)
          // 去除末尾多余的 .00 或 .0
          result = result.replace(/\.00$/, '').replace(/(\.\d)0$/, '$1')
          return result + '万'
        }
        return inputString
      },
      selectTabs1(val) {
        let params = {
          beginTime: '',
          endTime: '',
        }
        if (val == 1) {
          // 获取当前日期
          const today = new Date()
          // 计算昨天的日期（当前时间减去一天的毫秒数）
          const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)

          // 格式化日期为 yyyy-mm-dd 格式
          const year = yesterday.getFullYear()
          const month = String(yesterday.getMonth() + 1).padStart(2, '0')
          const day = String(yesterday.getDate()).padStart(2, '0')
          const dateStr = `${year}-${month}-${day}`

          // 赋值时间
          params.beginTime = `${dateStr} 00:00:00`
          params.endTime = `${dateStr} 23:59:59`
        } else {
          // 获取当前日期
          const today = new Date()

          // 处理开始时间：本月1号 00:00:00
          const firstDayOfMonth = new Date(
            today.getFullYear(),
            today.getMonth(),
            1
          )
          const startYear = firstDayOfMonth.getFullYear()
          const startMonth = String(firstDayOfMonth.getMonth() + 1).padStart(
            2,
            '0'
          )
          const startDay = String(firstDayOfMonth.getDate()).padStart(2, '0')
          params.beginTime = `${startYear}-${startMonth}-${startDay} 00:00:00`

          // 处理结束时间：今日 23:59:59
          const endYear = today.getFullYear()
          const endMonth = String(today.getMonth() + 1).padStart(2, '0')
          const endDay = String(today.getDate()).padStart(2, '0')
          params.endTime = `${endYear}-${endMonth}-${endDay} 23:59:59`
        }

        performanceHomeOverviewList(params).then((res) => {
          this.source1 = res.data
        })
      },
      selectTabs2(val) {
        let params = {
          beginTime: '',
          endTime: '',
        }
        if (val == 1) {
          // 获取当前日期
          const today = new Date()
          // 计算昨天的日期（当前时间减去一天的毫秒数）
          const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)

          // 格式化日期为 yyyy-mm-dd 格式
          const year = yesterday.getFullYear()
          const month = String(yesterday.getMonth() + 1).padStart(2, '0')
          const day = String(yesterday.getDate()).padStart(2, '0')
          const dateStr = `${year}-${month}-${day}`

          // 赋值时间
          params.beginTime = `${dateStr} 00:00:00`
          params.endTime = `${dateStr} 23:59:59`
        } else {
          // 获取当前日期
          const today = new Date()

          // 处理开始时间：本月1号 00:00:00
          const firstDayOfMonth = new Date(
            today.getFullYear(),
            today.getMonth(),
            1
          )
          const startYear = firstDayOfMonth.getFullYear()
          const startMonth = String(firstDayOfMonth.getMonth() + 1).padStart(
            2,
            '0'
          )
          const startDay = String(firstDayOfMonth.getDate()).padStart(2, '0')
          params.beginTime = `${startYear}-${startMonth}-${startDay} 00:00:00`

          // 处理结束时间：今日 23:59:59
          const endYear = today.getFullYear()
          const endMonth = String(today.getMonth() + 1).padStart(2, '0')
          const endDay = String(today.getDate()).padStart(2, '0')
          params.endTime = `${endYear}-${endMonth}-${endDay} 23:59:59`
        }

        shopHomeOverviewList(params).then((res) => {
          this.source2 = res.data
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .home {
    padding-top: 10px;
    background: #f3f3f3;
    .text-muted {
      width: 117px;
    }
    blockquote {
      padding: 10px 20px;
      margin: 0 0 20px;
      font-size: 17.5px;
      border-left: 5px solid #eee;
    }

    hr {
      margin-top: 20px;
      margin-bottom: 20px;
      border: 0;
      border-top: 1px solid #eee;
    }

    .col-item {
      margin-bottom: 20px;
    }

    ul {
      padding: 0;
      margin: 0;
    }

    font-family: 'open sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 13px;
    color: #676a6c;
    overflow-x: hidden;

    ul {
      list-style-type: none;
    }

    h4 {
      margin-top: 0px;
    }

    h2 {
      margin-top: 10px;
      font-size: 26px;
      font-weight: 100;
    }

    p {
      margin-top: 10px;

      b {
        font-weight: 700;
      }
    }

    .update-log {
      ol {
        display: block;
        list-style-type: decimal;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0;
        margin-inline-end: 0;
        padding-inline-start: 40px;
      }
    }
  }

  .order-item {
    cursor: pointer;
    flex: 1;
    align-items: center;
    border: 1px solid transparent;
  }

  .changyong {
    width: 100px;
    cursor: pointer;
    align-items: center;
    border: 1px solid transparent;
  }

  .changyong:hover {
    border: 1px solid #6ebaff;
    background: #e6f3ffc8;
  }

  .order-item:hover {
    border: 1px solid #6ebaff;
    background: #e6f3ffc8;
  }

  .iconitem {
    border-radius: 50%;
    background: #60a9ff;
    height: 56px;
    width: 56px;
    line-height: 56px;
    font-size: 14px;
    text-align: center;
    color: #fff;
  }

  .childItem {
    background: #eee;
    padding: 20px 15px;
    margin: 10px 10px 10px 0;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid transparent;
    width: 220px;
  }

  .childItem:hover {
    border: 1px solid #6ebaff;
    background: #e6f3ffc8;
  }
  .item {
    .title {
      font-size: 14px;
    }
    .price {
      color: #2589ff;
      font-size: 26px;
      font-weight: 400;
      margin-bottom: 10px;
    }
  }
</style>
